import Vue from 'vue'
import Vuex from 'vuex'
import company from './modules/company'
import language from './modules/language'
import message from './modules/message'
import user from './modules/user'
import ui from './modules/ui'
import mobileapp from './modules/mobileapp'
import orders from './modules/orders'
import followup from './modules/followup'
import reminder from './modules/reminder'
import permission from './modules/permission'
import subscriptions from './modules/subscriptions'
import constants from './modules/constants'
import tours from './modules/tours'
import currency from './modules/currency'
import riders from './modules/riders'
import customers from './modules/customers'
import donation from './modules/donation'
import clinic from './modules/clinic'
import review from './modules/review'

import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: { user, company, language, message, ui, mobileapp, orders, followup, reminder, permission, subscriptions, constants, tours, currency, riders, customers, donation, clinic, review },
  plugins: [createPersistedState({ key: 'pc', paths: ['user'] })]
})

window.$store = store

export default store
